<template>
  <div
    :class="[
      twMerge(
        'grid w-full grid-cols-1 gap-y-4 xl:grid-cols-10 xl:gap-x-8 xl:gap-y-0',
        attrs.class,
      ),
    ]"
  >
    <div
      :class="[
        twMerge(
          'col-span-4 flex w-full max-w-full flex-col justify-start gap-y-4',
          descriptionsTitleContainerClasses,
        ),
      ]"
    >
      <h3 v-if="descriptionsTitle" class="text-pretty text-2xl font-bold">
        {{ descriptionsTitle }}
      </h3>
      <span
        v-for="(description, index) in descriptionsItems"
        :key="index"
        class="text-pretty text-base leading-5"
      >
        {{ description }}
      </span>
      <slot />
    </div>
    <div
      :class="[
        twMerge(
          'col-span-6 flex w-full max-w-full flex-col gap-y-3',
          servicesContainerClasses,
        ),
      ]"
    >
      <span v-if="servicesTitle" class="text-base font-semibold">
        {{ servicesTitle }}
      </span>
      <div
        :class="[
          'grid w-full max-w-full gap-4 xl:grid-cols-2 xl:grid-rows-2',
          twMerge(servicesItemsClasses),
        ]"
      >
        <PackageService
          v-for="(service, index) in servicesItems"
          :key="index"
          :service="service"
          :class="service.classes"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
/** packages */
import { twMerge } from 'tailwind-merge'

/** types */
import type { TCDPackageService } from '~/src/types/capacity-database'
import type { TGeneral } from '~/src/types/common'

/** components */
const PackageService = defineAsyncComponent(
  () => import('~/components/capacity-database/PackageService.vue'),
)

/** props */
withDefaults(
  defineProps<{
    descriptionsTitle?: string | null
    descriptionsItems?: string[]
    descriptionsTitleContainerClasses?: string
    servicesTitle?: string | null
    servicesItems?: TCDPackageService[]
    servicesContainerClasses?: string
    servicesItemsClasses?: string
  }>(),
  {
    descriptionsTitle: null,
    descriptionsItems: () => [],
    descriptionsTitleContainerClasses: '',
    servicesTitle: null,
    servicesItems: () => [],
    servicesContainerClasses: '',
    servicesItemsClasses: '',
  },
)

/** app */
const attrs = useAttrs() as TGeneral
</script>
